import React from 'react';
import { Card, Space, Button } from '@douyinfe/semi-ui';
import { IconDownloadStroked } from '@douyinfe/semi-icons';

import SetupWizard from '../Setup/SetupWizard';

class NotInit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            wizardOpen: false
        };
    }

    openWizard = (value) => {
        this.setState({ wizardOpen: value });
    };

    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <SetupWizard toaster={this.props.toaster} openState={this.state.wizardOpen} openWizard={this.openWizard} />
                <Space vertical align="center">
                    <Card
                        title={<h3 style={{ textAlign: 'center', width: '100%' }}>Платформа не инициализирована.</h3>}
                        style={{ textAlign: 'center', maxWidth: 400 }}
                        bodyStyle={{ padding: 16 }}
                        bordered
                    >
                        <span className="deniedSpan">Для начала работы в системе необходимо произвести ее инициализацию.</span>
                        <Button
                            icon={<IconDownloadStroked />}
                            onClick={() => this.setState({ wizardOpen: true })}
                            theme="borderless"
                            style={{ marginTop: 16 }}
                        >
                            Инициализация
                        </Button>
                    </Card>
                </Space>
            </div>
        );
    }
}

export default NotInit;